import { ArrowBackIosNew } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";
import ShareIcon from "@mui/icons-material/Share";
import { Box, Typography, styled } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useRef } from "react";
import { RWebShare } from "react-web-share";
import { primary } from "../../../constants/theme";
import { VehicleBrochure } from "../../../constants/vehicleData";
import { sendAnalytics } from "../../../utils/analyticsCommon";
const CustomWebShare = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  padding: "0 10px",
  margin: "auto",
  ".icons_container": {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    paddingTop: "8px",
  },
  ".icon": {
    display: "none",
  },
  ".icon_container": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
  },

  [theme.breakpoints.down("md")]: {
    ".icon": {
      display: "none",
    },
  },
  [theme.breakpoints.down("sm")]: {
    ".icon": {
      display: "block",
      background: primary?.lightPink,
      color: primary.main,
      width: "40px",
      textAlign: "center",
      borderRadius: "100px",
      height: "40px",
      padding: "10px 8px 10px 8px ",
      justifySelf: "flex-start",
      backgroundShadow: "2px 2px grey",
    },
    ".icon_text": {
      fontSize: "10px",
      textAlign: "center",
      color: primary.greyText,
    },
  },
}));
const WebShare = ({ vehicleData }) => {
  const navigate = useRouter();
  const targetRef1 = useRef();
  return (
    <CustomWebShare>
      <Box className="icons_container">
        <Box>
          <ArrowBackIosNew
            onClick={() => navigate.back()}
            color="black"
            className="icon"
            sx={{ display: { xs: "block", md: "none" } }}
          />
        </Box>
        <Box className="icon_container">
          <Box>
            <RWebShare
              data={{
                text: "Hi, Checkout this Amazing EV Gaadi",
                // url: document.location.href,
                title: "EV Gaadi",
              }}
              onClick={() => console.log("shared successfully!")}
            >
              <ShareIcon
                onClick={() => navigate.back()}
                color="black"
                className="icon"
                sx={{ display: { xs: "block", md: "none" } }}
              />
            </RWebShare>
            <Typography className="icon_text">Share</Typography>
          </Box>
          <Box>
            {/* <a href={VehicleBrochure[vehicleData?.brand?.toLowerCase()]} target="_blank" download>Download</a> */}
            {/* <Link
              ref={targetRef1}
              href={VehicleBrochure[vehicleData?.brand?.toLowerCase()]}
              hrefLang={"en"}
              style={{ textDecoration: "none" }} //underline was not working
              // target="_blank"
              download
              rel="noreferrer"
              underline="none"
              onClick={() => {
                e.preventDefault();
                let payload = {
                  vehicle_name: vehicleData?.vehicle_name,
                  vehicle_id: vehicleData?.vehicle_id,
                  price_shown: price,
                  emi_shown: emiPrice,
                  offer_name: offer_name,
                  offer_id: offer_id,
                  tag_name: tag_name,
                  tag_id: tag_id,
                };
                sendAnalytics(
                  "download_brouchure_button_clicked",
                  payload,
                  "en"
                );
              }}
            >
              <DownloadIcon
                //onClick={() => navigate.back()}
                color="black"
                className="icon"
                sx={{ display: { xs: "block", md: "none" } }}
              />
              <Typography className="icon_text">Brochure</Typography>
            </Link> */}
            {
            vehicleData?.vehicle_name ==='Storm EV' ? null :
            <a
              style={{ textDecoration: "none" }}
              href={
                vehicleData?.brochure_url
                  ? vehicleData?.brochure_url
                  : VehicleBrochure[vehicleData?.brand?.toLowerCase()]
              }
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                // e.preventDefault();
                let payload = {
                  vehicle_name: vehicleData?.vehicle_name,
                  vehicle_id: vehicleData?.vehicle_id,
                  price_shown: price,
                  emi_shown: emiPrice,
                  offer_name: offer_name,
                  offer_id: offer_id,
                  tag_name: tag_name,
                  tag_id: tag_id,
                };
                sendAnalytics(
                  "download_brouchure_button_clicked",
                  payload,
                  "en"
                );
              }}
            >
              <DownloadIcon
                color="black"
                className="icon"
                sx={{ display: { xs: "block", md: "none" } }}
              />
              <Typography className="icon_text">Brochure</Typography>
            </a>
            }
          </Box>
        </Box>
      </Box>
    </CustomWebShare>
  );
};

export default WebShare;
